import React, { lazy, Suspense, memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loading from 'components/shared-components/Loading';
import Views from 'views';
import { signOutSuccess } from 'store/slices/authSlice';
import { AUTH_TOKEN, AUTH_TOKEN_EXPIRY } from 'constants/AuthConstant';

const AppLayout = lazy(() => import('./AppLayout'));
const AuthLayout = lazy(() => import('./AuthLayout'));

const Layouts = () => {
  const token = useSelector((state) => state.auth.token);
  const blankLayout = useSelector((state) => state.theme.blankLayout);
  const direction = useSelector((state) => state.theme.direction);
  const navType = useSelector((state) => state.theme.navType);
  const navCollapsed = useSelector((state) => state.theme.navCollapsed);

  const Layout = token && !blankLayout ? AppLayout : AuthLayout;
  console.log('token fetched', token)

  const dispatch = useDispatch();

  const isAuthTokenExpired = () => {
    const expiry = localStorage.getItem(AUTH_TOKEN_EXPIRY);
    if (!expiry) return true; // No expiry means invalid
    return Date.now() > parseInt(expiry);
  };

  useEffect(() => {
    // const token = localStorage.getItem(AUTH_TOKEN);
    const expiry = localStorage.getItem(AUTH_TOKEN_EXPIRY);

    if (!token || !expiry || isAuthTokenExpired()) {
      dispatch(signOutSuccess());
      return;
    }

    // Calculate how much time is left until token expires
    const remainingTime = parseInt(expiry) - Date.now();

    // Set timer to auto-logout
    const timer = setTimeout(() => {
      dispatch(signOutSuccess());
    }, remainingTime);

    // Cleanup the timer on unmount
    return () => clearTimeout(timer);
  }, [dispatch, token]);

  return (
    <Suspense fallback={<Loading cover='content' />}>
      <Layout
        direction={direction}
        navType={navType}
        navCollapsed={navCollapsed}
      >
        <Views />
      </Layout>
    </Suspense>
  );
};

export default memo(Layouts);
